import axios from 'axios';
import {UNAUTHORIZED} from 'http-status-codes';
import {check, getAuthorizationToken} from './utils/tokenUtils';
import legacyParamsSerializer from './utils/legacyParamsSerializer';
import AuthorizationHandler from './authorizationHandler';
import store, {history} from './store';

const BASE_URL = '/';

const token = getAuthorizationToken();

if (token && check()) {
  axios.defaults.headers.common.Authorization = `Bearer ${token}`;
}

const irelandApi = axios.create({
  baseURL: BASE_URL,
  headers: {
    Accept: 'application/json',
  },
  // Restore axios 0.x param serialization (nested objects -> JSON string) so the Rails admin
  // search filters that do JSON.parse(params[:q]) keep working after the axios 1.x upgrade.
  // See ./utils/legacyParamsSerializer for the full rationale.
  paramsSerializer: {
    serialize: legacyParamsSerializer,
  },
});

const handleResponse = response => response;

const handleError = (error) => {
  // `error.response` is undefined on a gateway/network error (a 502/504 that reaches the
  // browser without CORS headers, a connection reset, or a client timeout). Reading
  // `error.response.status` directly used to throw a TypeError here — guard it.
  const status = error.response ? error.response.status : undefined;
  const {pathname: path} = window.location;
  const {dispatch} = store;

  const authHandler = new AuthorizationHandler(path);

  if ((status === UNAUTHORIZED || !getAuthorizationToken()) && authHandler.shouldResolve()) {
    dispatch({ type: 'SAVE_REQUESTED_PATH', payLoad: path });
    authHandler.resolveError()(dispatch, history);
  }

  return Promise.reject(error);
};

irelandApi.interceptors.response.use(handleResponse, handleError);

// eslint-disable-next-line no-unused-vars
irelandApi.mock = (url, payLoad = null, time = 1000) => new Promise(resolve => setTimeout(resolve, time));

export default irelandApi;
